import { ChangeDetectionStrategy, Component, inject, input, InputSignal, Signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FloatingDirective } from '@core/directives/floating/floating.directive';
import { OverlayPosition } from '@core/directives/floating/floating.types';
import { IconModule } from '@ogs-gmbh/ngx-m3-components';
import { LanguageSelectionService } from '../../services/language-selection/language-selection.service';
import { MatListModule } from '@angular/material/list';
import { LocaleConfig, provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { MatSelectModule } from '@angular/material/select';
import { MatPseudoCheckbox, MatPseudoCheckboxModule } from '@angular/material/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-language-select-menu-item',
  standalone: true,
  imports: [ MatMenuModule,
    FloatingDirective,
    IconModule,
    MatListModule,
    MatSelectModule,
    MatPseudoCheckboxModule,
    MatPseudoCheckbox,
    TranslationPipeModule ],
  templateUrl: './language-select-menu-item.component.html',
  styleUrl: './language-select-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ provideTranslationScope("shared/language-select-menu-item") ]
})
export class LanguageSelectMenuItemComponent {
  protected _languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);

  public menuPosition: InputSignal<OverlayPosition> = input("left" as OverlayPosition);


  protected currentLocale: Signal<LocaleConfig | undefined> = toSignal(this._languageSelectionService.currentLocale$);

  protected onSelectionChange (newLocale: LocaleConfig): void {
    this._languageSelectionService.setLocale(newLocale);
  }
}
